// The message for a field's error code: the SEPA provider rejected the value
// (invalid_for_sepa, from signup-api), otherwise the field is blank
const fieldErrorKey = (code) =>
  code === 'invalid_for_sepa' ? 'signup.profile.error.invalid_for_sepa' : 'signup.profile.error.blank'

export default fieldErrorKey
